import React, { useEffect, useState } from "react";

import "./productGrid.css";
import { styled } from "@mui/material/styles";
import Table from "../../components/table/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllProduct,
  fetchFilterProduct,
  editProductInitialization,
  addItemStorage_Edit,
} from "../../redux/features/product.features";
// import { showSuccess } from "../../redux/features/alertbox.features";
// import StatusCard from "../../components/menu-button/StatusCard";
import StatusCard from "../../components/status-card/StatusCard";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { Button, ButtonGroup, Icon, TextField } from "@mui/material";
import Badge from "../../components/badge/Badge";
import { MobileDatePicker } from "@mui/lab";
import ProductEditor from "./product_edit";
import Modal from "../../components/modal/Modal";
import { Box } from "@mui/system";
import ProductView from "./ProductView";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

const renderHead = (item, index) => (
  <th className="selected" key={index}>
    {item}
  </th>
);

const finalTableHead = [
  "Actions",
  "Item ID",
  "Title",
  "Category",
  // "Description",
  "Enter Date",
  "Clarity",
  "Re-cut",
  "Treatment",
  "Origin",
  "Shape",
  "Weight",
  "Dimension",
  "Buy Price",
  "Sell Price (Local)",
  "Sell Price (Foreign)",
 
];

const initialValues = {
  sort: "Desc",
  limit: 10,
  treatment_type: "",
  need_recut: "",
  startDate: "",
  endDate: "",
  clarity: "",
  productId: "",
  title: "",
  description: "",
  date: "",
  origin: "",
  shape: "",
  weight: "",
  category: "",
  dimensionHeight: "",
  dimensionWidth: "",
  dimensionDepth: "",
  buyCurrency: "",
  buyPrice: "",
  sellPriceLocal: "",
  sellLocalCurrency: "",
  sellForeignersCurrency: "",
  sellPriceForeigners: "",
  isSold: "",
};

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const ProductManagement = ({ productModalPopUp }) => {
  const [values, setValues] = useState(initialValues);
  const [viewData, setviewData] = useState({});

  const [titlesList, setTitlesList] = useState([]);

  const [originList, setOriginList] = useState([]);
  const [preciousProduct, setpreciousProduct] = useState([]);
  const [semiPreciousProduct, setsemiPreciousProduct] = useState([]);
  const [needToReCutProducts, setneedToReCutProducts] = useState([]);
  const [shapeList, setShapeList] = useState([]);

  const [selectedDate, setEnterDate] = React.useState(new Date());
  const [showEdit, setEditShow] = React.useState(false);
  const [canShow, setShow] = React.useState(false);
  const toggleModal = {
    // setShow((state) => !state);
  };

  let storageBoxState = useSelector((state) => {
    return state.storageBoxReducer;
  });

  let { storageBox } = storageBoxState;


  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setValues({
      ...values,
      [name]: value,
    });
  };
  const finalRenderBody = (item, index, canShow, toggleModal) => {
    const clickToView = (item) => {
      setviewData(item);
      setShow((state) => !state);
    };

    const clickToEdit = (item) => {
    console.log("storageBox ", storageBox)
    let value = item?.storageBoxName  
    let ItemStorage = {
      storageBoxName: value,
      storageSlot: item?.storageSlot,
      storageBoxRowSize: storageBox
        .filter((x) => x.storageBoxName === value)
        .map((y) => y.storageBoxRowSize)[0],
      storageBoxColumnSize: storageBox
        .filter((x) => x.storageBoxName === value)
        .map((y) => y.storageBoxColumnSize)[0],
    };
     
      // dispatch(addItemStorage_Edit(ItemStorage));
      let editItem = {...item , ItemStorage}
      console.log("editItem selected ", editItem)
      dispatch(editProductInitialization(editItem));
      setviewData(item);
      setEditShow((state) => !state);
    };

    return (
      <>
        {item?.isSold ? (
          <HtmlTooltip
            title={
              <React.Fragment>
                {`This item is sold , Invoice Number is : ${item.invoiceNumber}`}
              </React.Fragment>
            }
          >
            <tr
              style={{
                color: "#fff",
                backgroundColor: item?.isSold ? "#a20b0b" : "inherit",
              }}
              onClick={(e) => {
                if (e.target.cellIndex && e.target.cellIndex !== 0)
                  clickToView(item);
              }}
              // onClick={() => clickToView(item)}
              key={index || 0}
            >
              <td
                style={{  backgroundColor: "var(--main-bg)" }}
                className="text-right flex items-center"
              >
                <div
                  onClick={() => {
                    clickToEdit(item);
                  }}
                  className="bg-red-500 rounded p-2 bx bx-edit mx-2"
                ></div>
                <div
                  onClick={() => {
                    clickToView(item);
                  }}
                  className="bg-green-500 rounded p-2 bx bx-show mx-2"
                ></div>
              </td>
              <td>{item.productId}</td>
              <td>{item.title}</td>
              <td>{item.category}</td>
              {/* <td>{item.description}</td> */}
              <td>{item.date}</td>
              <td>{item.clarity}</td>
              <td>{item.need_recut}</td>
              <td>{item.treatment_type}</td>
              <td>{item.origin}</td>
              <td>{item.shape}</td>
              <td>{item.weight}</td>
              <td>
                {item.dimensionHeight +
                  "*" +
                  item.dimensionWidth +
                  "*" +
                  item.dimensionDepth}
              </td>
              <td className="text-right">
                {Number(item.buyPrice).toLocaleString()} {item.buyCurrency}
              </td>
              <td className="text-right">
                {Number(item.sellPriceLocal).toLocaleString()}{" "}
                {item.sellLocalCurrency}
              </td>
              <td className="text-right">
                {Number(item.sellPriceForeigners).toLocaleString()}{" "}
                {item.sellForeignersCurrency}
              </td>
            </tr>
          </HtmlTooltip>
        ) : (
          <tr
            style={{
              color: "#fff",
             
            }}
            onClick={(e) => {
              if (e.target.cellIndex && e.target.cellIndex !== 0)
                clickToView(item);
            }}
            key={index || 0}
          >
            <td className="text-right flex items-center">
              <div
                onClick={() => {
                  clickToEdit(item);
                }}
                className="bg-red-500 rounded p-2 bx bx-edit mx-2"
              ></div>
              <div
                onClick={() => {
                  clickToView(item);
                }}
                className="bg-green-500 rounded p-2 bx bx-show mx-2"
              ></div>
            </td>
            <td>{item.productId}</td>
            <td>{item.title}</td>
            <td>{item.category}</td>
            {/* <td>{item.description}</td> */}
            <td>{item.date}</td>
            <td>{item.clarity}</td>
            <td>{item.need_recut}</td>
            <td>{item.treatment_type}</td>
            <td>{item.origin}</td>
            <td>{item.shape}</td>
            <td>{item.weight}</td>
            <td>
              {item.dimensionHeight +
                "*" +
                item.dimensionWidth +
                "*" +
                item.dimensionDepth}
            </td>
            <td className="text-right">
              {Number(item.buyPrice).toLocaleString()} {item.buyCurrency}
            </td>
            <td className="text-right">
              {Number(item.sellPriceLocal).toLocaleString()}{" "}
              {item.sellLocalCurrency}
            </td>
            <td className="text-right">
              {Number(item.sellPriceForeigners).toLocaleString()}{" "}
              {item.sellForeignersCurrency}
            </td>
          </tr>
        )}
      </>
    );
  };
  let dispatch = useDispatch();
  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let titlesState = useSelector((state) => {
    return state.titlesReducer;
  });

  let shapesState = useSelector((state) => {
    return state.shapesReducer;
  });
  let originState = useSelector((state) => {
    return state.originReducer;
  });

  let { titles } = titlesState;

  let { shapes } = shapesState;
  let { origin } = originState;
  let { stepOne } = productState;

  useEffect(() => {
    dispatch(fetchAllProduct());
    dispatch(fetchFilterProduct({}));
  }, [dispatch]);

  let { products, filteredproducts, loading } = productState || {
    products: [],
    loading: false,
  };

  useEffect(() => {
    if (products) {
      setpreciousProduct(products.filter((x) => x.category === "Precious"));
      setsemiPreciousProduct(products.filter((x) => x.category === "Semi"));
      setneedToReCutProducts(products.filter((x) => x.need_recut === "Yes"));
    }
  }, [products]);

  // useEffect(() => {
  //   setFilterData((e) => [...e, values.clarity]);
  // }, [values]);

  const search = () => {
    let saveData = values;
    if (selectedDate !== "") {
      let dateSave = new Date(selectedDate).toISOString().substring(0, 10);
      saveData.date = dateSave;
    } else {
      saveData.date = "";
    }

    // if(values.productId && values.productId.split(",").length >1){
    //   saveData.productId=  saveData.productId.split(",")
    //   console.log(saveData.productId)
    // }

    dispatch(fetchFilterProduct(saveData));
  };

  const clearDate = () => setEnterDate("");

  useEffect(() => {
    let a = [];
    titles.map((x) => {
      return a.push(x.titlesName);
    });
    setTitlesList(a);
  }, [titles]);

  useEffect(() => {
    let a = [];
    shapes.map((x) => {
      return a.push(x.shapesName);
    });
    setShapeList(a);
  }, [shapes]);

  const print = () => {
    console.log("print clicked");
    var content = document.getElementById("divcontents");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };

  useEffect(() => {
    console.log("titles", titles);
    var filteredData = titles.filter(
      (x) => x.titlesCategory === values.category
    );
    console.log("filteredData", filteredData);
    var arr = [];
    filteredData.map((x) => arr.push(x.titlesName));
    console.log("arr", arr);
    setTitlesList(arr);
  }, [titles, values]);

  useEffect(() => {
    dispatch(fetchFilterProduct({}));
  }, [products]);

  return (
    <div style={{ zIndex: "unset" }}>
      <div className="row">
        <div className="col-3">
          <StatusCard
            icon={"bx bx-diamond"}
            count={products.length}
            title={"Products"}
          ></StatusCard>
        </div>
        <div className="col-3">
          <StatusCard
            icon={"bx bx-diamond"}
            count={preciousProduct.length}
            title={"Precious Products"}
          ></StatusCard>
        </div>
        <div className="col-3">
          <StatusCard
            icon={"bx bx-diamond"}
            count={semiPreciousProduct.length}
            title={"Semi Precious Products"}
          ></StatusCard>
        </div>
        <div className="col-3">
          <StatusCard
            icon={"bx bx-diamond"}
            count={needToReCutProducts.length}
            title={"Need to recut Products"}
          ></StatusCard>
        </div>
        {/* filter area */}
        <div className="col-12">
          <div
            style={{ padding: 20, backgroundColor: "var(--main-bg)" }}
            className="row"
          >
            <h5 style={{ padding: 15, fontSize: "1rem", fontWeight: 700 }}>
              Filters
            </h5>
            <div className="row col-12">
              <div className="col-2">
                <TextField
                  style={{ color: "white", marginBottom: 16 }}
                  fullWidth
                  id="outlined-required"
                  label="Item Id"
                  placeholder="enter item id..."
                  defaultValue=""
                  color="warning"
                  name="productId"
                  value={values.productId}
                  onChange={handleChange}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={["Precious", "Semi"]}
                  onChange={handleChange}
                  title="Category"
                  name="category"
                  value={values.category}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={titlesList}
                  onChange={handleChange}
                  title="Titles"
                  name="title"
                  value={values.title}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={shapeList}
                  onChange={handleChange}
                  title="Gem Shape"
                  name="shape"
                  value={values.shape}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={["Eye Clean", "Lupe clean"]}
                  onChange={handleChange}
                  title="Gem Clarity"
                  name="clarity"
                  value={values.clarity}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={origin}
                  onChange={handleChange}
                  title="Gem Origin"
                  name="origin"
                  value={values.origin}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={["Heated", "Un-Heated", "?"]}
                  onChange={handleChange}
                  title="Treatment type"
                  name="treatment_type"
                  value={values.treatment_type}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={["All", "Sold", "Stock"]}
                  onChange={handleChange}
                  title="Sales Filter"
                  name="isSold"
                  value={values.isSold}
                />
              </div>
              <div className="col-2">
                <CustomSelectBox
                  items={["Desc", "Asc"]}
                  onChange={handleChange}
                  title="Item ID Sort"
                  name="sort"
                  value={values.sort}
                />
              </div>
              <div className="row col-3 flex items-center">
                <div className="col-6">
                  <MobileDatePicker
                    label="Enter Date"
                    inputFormat="dd/MM/yyyy"
                    value={selectedDate}
                    name="date"
                    onChange={(selectedDate) => {
                      console.log(selectedDate);

                      setEnterDate(selectedDate);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </div>
                <Button onClick={clearDate} color="warning">
                  Clear date
                </Button>
              </div>
              <div className="col-12">
                <ButtonGroup
                  fullWidth
                  variant="contained"
                  aria-label="outlined primary button group"
                  style={{ marginTop: 15 }}
                >
                  <Button
                    style={{ padding: 15, fontSize: "1rem" }}
                    onClick={() => {
                      setValues(initialValues);
                      setEnterDate("");
                      search();
                    }}
                    color="warning"
                  >
                    Clear
                  </Button>
                  <Button
                    style={{ padding: 15, fontSize: "1rem" }}
                    onClick={search}
                    color="success"
                  >
                    Search
                    <i
                      style={{ padding: 5, fontSize: "1rem" }}
                      className="bx bx-arrow-from-left"
                    ></i>
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6"></div>
            <div className="col-6">
              <ButtonGroup
                fullWidth
                variant="contained"
                aria-label="outlined primary button group"
                style={{ margin: 5, padding: 15, marginLeft: 25 }}
              >
                <Button
                  style={{ padding: 15, fontSize: "1rem", fontWeight: 700 }}
                  color="info"
                  onClick={print}
                >
                  {" "}
                  <i
                    style={{ padding: 5, fontSize: "1rem" }}
                    className="bx bx-printer"
                  ></i>{" "}
                  Print
                </Button>
                <Button
                  style={{ padding: 15, fontSize: "1rem", fontWeight: 700 }}
                  color="error"
                >
                  <i
                    style={{ padding: 5, fontSize: "1rem" }}
                    className="bx bxs-file-doc"
                  ></i>{" "}
                  Export Pdf
                </Button>
                <Button
                  style={{ padding: 15, fontSize: "1rem", fontWeight: 700 }}
                  color="success"
                >
                  <i
                    style={{ padding: 5, fontSize: "1rem" }}
                    className="bx bxs-file-find"
                  ></i>{" "}
                  Export Excel
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </div>
        <iframe
          id="ifmcontentstoprint"
          style={{ height: 0, width: 0, position: "absolute" }}
        />

        <div className="col-12 my-4">
          <div className="card">
            <div className="card__body">
              {loading ? (
                <p>loading...</p>
              ) : (
                <>
                  <Table
                    id="divcontents"
                    showLimit
                    limit={values.limit}
                    headData={finalTableHead}
                    renderHead={(item, index) => renderHead(item, index)}
                    bodyData={filteredproducts}
                    renderBody={(item, index) =>
                      finalRenderBody(item, index, canShow, toggleModal)
                    }
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        modal_title={"View Product"}
        canShow={canShow}
        updateModalState={() => setShow((state) => !state)}
      >
        <Box>
          <ProductView data={viewData} />
        </Box>
      </Modal>
      <Modal
        modal_title={"Edit Product"}
        canShow={showEdit}
        updateModalState={() => setEditShow((state) => !state)}
      >
        <Box>
          <ProductEditor
            onClose={() => setEditShow((state) => !state)}
            data={viewData}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default ProductManagement;
